import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
} from "@mui/material";
import { cloneDeep, merge } from "lodash";
import { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import HLTextField from "../../../shared/components/Form/HLTextField";
import { PartitionKeyEnum } from "../../../shared/enums";
import { hasDirtyFields } from "../../../shared/helpers/hasDirtyFields";
import { ConfigDataContext } from "../../../shared/providers/ConfigDataProvider";
import { SET_CONFIG_DATA } from "../../../shared/reducer/configDataReducer";

interface IProducPricesDialog {
  partitionKey: string;
  handleCloseDialog: () => void;
}

/**
 * Form dialog for updating product prices
 * @param partitionKey of product being edited
 * @param handleCloseDialog fn for closing dialog
 */
const ProductPricesDialog = ({
  partitionKey,
  handleCloseDialog,
}: IProducPricesDialog) => {
  // Load state and reducer dispatch
  const { state, dispatch } = useContext(ConfigDataContext);

  // Initialise RHF and helper fn
  const methods = useForm({
    defaultValues: state || {},
  });
  const {
    formState: { isSubmitSuccessful },
  } = methods;

  // Merge formData into cloned data structure and dispatch
  const handleSubmit = (formData: any) =>
    dispatch({
      type: SET_CONFIG_DATA,
      payload: merge(cloneDeep(state), formData),
    });

  // Bypass memory leak cause by not consitently mounting dialog
  useEffect(() => {
    if (!isSubmitSuccessful) return;
    handleCloseDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitSuccessful]);

  return (
    <Dialog open onClose={handleCloseDialog}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogContent>
            <HLTextField
              label={
                //@ts-ignore - TS does not like using strings as enum property references
                PartitionKeyEnum[partitionKey] + " Preis"
              }
              name={`data.${partitionKey}`}
              type="number"
              InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
              }}
              margin="normal"
              required
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={!hasDirtyFields(methods)}
            >
              Speichern
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default ProductPricesDialog;
